const BookingStates = {
    CREATED: 'created',
    WAITING_FOR_CONFIRMATION: 'waiting_for_confirmation',
    CONFIRMED: 'confirmed',
    REJECTED_BY_PROVIDER: 'rejected_by_provider',
    CANCELLED_BY_CUSTOMER: 'cancelled_by_customer'
}

const BookingTypes = {
    RESERVATION_ONLY: 'reservation_only',
    ON_REQUEST: 'on_request',
    DIRECT: 'direct'
}

module.exports = {
    BookingStates,
    BookingTypes
}